import Box from "@mui/material/Box";
import React from "react";
import {useUserContext} from "../../contexts/UserContext";
import {DealPageAdditionalInfo} from "./DealPageAdditionalInfo";
import {DealPageSuperUserSection} from "./DealPageSuperUserSection";
import Stack from "@mui/material/Stack";
import {DealPageDrawerHeader} from "./DealPageDrawerHeader";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const DealPageDrawer = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { isSuperUser } = useUserContext()

    return (
        <Box
            style={{
                margin: isTabletOrMobile ? '30px 0 0 0' : '0 0 0 20px',
                minWidth: '365px',
            }}
        >

            <Stack
                direction="column"
                alignItems="center"
            >
                {
                    !isTabletOrMobile &&
                    <DealPageDrawerHeader/>
                }

                <DealPageAdditionalInfo/>

                {
                    isSuperUser() &&
                    <DealPageSuperUserSection/>
                }
            </Stack>
        </Box>
    )
}